import React from "react";
import logo from "./../../images/grok pvt ltd logo.png";
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import "./enrollmentMenu.css";

const EnrollmentMenu = () => {
    const navigate = useNavigate();
    const IndEnroll = async  () => {
        navigate('/enrollIndustry',{state: { companyid: null} });
    }

    const AcadEnroll = () => {
        navigate('/enrollAcademicInst', {state: { collegeid: null} });
    }

    return (
        <div className="hackathonHeader">
            <header>
                <div>
                    <img src={logo} alt="" height={"50px"} width={"200px"} />
                </div>
                <div>
                    <div className='text-center flex-grow-1'>
                        <h4 className='landing_head'>Grok Industry Academia Collaboration</h4>
                    </div>
                </div>
                <div></div>
                <p></p>
            </header>

            <div style={{borderTop: "1px solid black"}}></div>
            <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
            <div className="landing-links">
                <Form className="d-flex">
                    <button className='loginBtn_style m-2' type='submit' onClick={() => AcadEnroll()}>
                        &nbsp;&nbsp;
                        Enroll as College/University
                    </button>
                </Form>
                <Form className="d-flex">
                    <button className='loginBtn_style m-2' type='submit' onClick={() => IndEnroll()}>
                        &nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Enroll as Industry
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </button>
                </Form>
            </div>
        </div>
    )
}

export default EnrollmentMenu;